import * as React from "react"
const NoTimelineImg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={203.525}
    height={128.548}
    {...props}
  >
    <g transform="translate(244.61)">
      <path
        fill="#3f3d56"
        d="M-187.071 115.691a2.912 2.912 0 0 0 .385-1.477 1.913 1.913 0 1 0-3.692 0 2.912 2.912 0 0 0 .385 1.477 3.025 3.025 0 0 0 0 2.954 3.025 3.025 0 0 0 0 2.954 3.025 3.025 0 0 0 0 2.954 2.909 2.909 0 0 0-.385 1.477 1.913 1.913 0 1 0 3.692 0 2.908 2.908 0 0 0-.385-1.476 3.025 3.025 0 0 0 0-2.954 3.025 3.025 0 0 0 0-2.954 3.025 3.025 0 0 0 0-2.954Z"
        data-name="Path 123629"
      />
      <ellipse
        cx={2.578}
        cy={3.376}
        fill="#3f3d56"
        data-name="Ellipse 130953"
        rx={2.578}
        ry={3.376}
        transform="translate(-194.645 101.065)"
      />
      <ellipse
        cx={2.578}
        cy={3.376}
        fill="#3f3d56"
        data-name="Ellipse 130954"
        rx={2.578}
        ry={3.376}
        transform="translate(-194.645 96.939)"
      />
      <path
        fill="#57b894"
        d="M-195.452 88.089a9 9 0 0 1-.687-1.013l4.851-.8-5.247.039a8.861 8.861 0 0 1-.168-7.008l7.039 3.652-6.488-4.769a8.846 8.846 0 1 1 14.607 9.9 8.885 8.885 0 0 1 1.008 1.613l-6.3 3.275 6.715-2.254a8.854 8.854 0 0 1-1.425 8.306 8.844 8.844 0 1 1-13.9 0 8.849 8.849 0 0 1 0-10.937Z"
        data-name="Path 123630"
      />
      <path
        d="M-179.65 93.558a8.81 8.81 0 0 1-1.892 5.468 8.844 8.844 0 1 1-13.9 0c-1.193-1.505 15.792-6.461 15.792-5.468Z"
        data-name="Path 123631"
        opacity={0.1}
      />
      <path
        fill="#3f3d56"
        d="M-61.572 120.366a1.862 1.862 0 0 0 .247-.945 1.224 1.224 0 1 0-2.361 0 1.861 1.861 0 0 0 .247.945 1.933 1.933 0 0 0 0 1.89 1.933 1.933 0 0 0 0 1.89 1.931 1.931 0 0 0 0 1.889 1.864 1.864 0 0 0-.247.945 1.224 1.224 0 1 0 2.361 0 1.864 1.864 0 0 0-.247-.945 1.931 1.931 0 0 0 0-1.889 1.933 1.933 0 0 0 0-1.89 1.933 1.933 0 0 0 0-1.89Z"
        data-name="Path 123632"
      />
      <ellipse
        cx={1.961}
        cy={2.568}
        fill="#3f3d56"
        data-name="Ellipse 130955"
        rx={1.961}
        ry={2.568}
        transform="translate(-60.744 107.696)"
      />
      <ellipse
        cx={1.961}
        cy={2.568}
        fill="#3f3d56"
        data-name="Ellipse 130956"
        rx={1.961}
        ry={2.568}
        transform="translate(-60.744 104.556)"
      />
      <path
        fill="#57b894"
        d="M-66.927 102.712a5.644 5.644 0 0 1-.44-.648l3.1-.51-3.357.026a5.676 5.676 0 0 1-.108-4.483l4.5 2.337-4.152-3.051a5.657 5.657 0 1 1 9.342 6.331 5.65 5.65 0 0 1 .646 1.031l-4.028 2.093 4.3-1.444a5.656 5.656 0 0 1-.912 5.313 5.657 5.657 0 1 1-8.892 0 5.658 5.658 0 0 1 0-6.995Z"
        data-name="Path 123633"
      />
      <path
        d="M-56.824 106.21a5.63 5.63 0 0 1-1.211 3.5 5.657 5.657 0 1 1-8.891 0c-.76-.966 10.102-4.135 10.102-3.5Z"
        data-name="Path 123634"
        opacity={0.1}
      />
      <path
        fill="#f1f1f1"
        d="M-73.42 33.077h-32.944v-7.124a1.7 1.7 0 0 0-1.7-1.7h-9.673v-7.59a1.073 1.073 0 0 0-1.073-1.073h-12.47a1.074 1.074 0 0 0-1.073 1.073v7.59h-11.368a1.7 1.7 0 0 0-1.709 1.7v7.119h-31.408a.347.347 0 0 0-.346.347v94.587a.347.347 0 0 0 .346.347h20.877a.349.349 0 0 0 .347-.347v-12.727a.349.349 0 0 1 .347-.347h8.819a.347.347 0 0 1 .346.347v12.727a.347.347 0 0 0 .344.347h41.258a.349.349 0 0 0 .346-.347v-12.727a.347.347 0 0 1 .344-.347h8.817a.347.347 0 0 1 .347.347v12.727a.349.349 0 0 0 .347.347h20.877a.349.349 0 0 0 .346-.347V33.425a.347.347 0 0 0-.344-.348Zm-85.931 77.442a.346.346 0 0 1-.344.344h-12.898a.344.344 0 0 1-.346-.344v-4.4a.346.346 0 0 1 .346-.347h12.9a.347.347 0 0 1 .344.347Zm0-11.381a.346.346 0 0 1-.344.346h-12.898a.346.346 0 0 1-.346-.347v-4.4a.346.346 0 0 1 .346-.347h12.9a.346.346 0 0 1 .344.347Zm0-11.377a.346.346 0 0 1-.344.346h-12.898a.346.346 0 0 1-.346-.346v-4.4a.346.346 0 0 1 .346-.347h12.9a.347.347 0 0 1 .344.347Zm0-11.381a.344.344 0 0 1-.344.346h-12.898a.344.344 0 0 1-.346-.346v-4.4a.344.344 0 0 1 .346-.346h12.9a.344.344 0 0 1 .344.346Zm0-11.379a.347.347 0 0 1-.344.347h-12.898a.346.346 0 0 1-.346-.347v-4.4a.344.344 0 0 1 .346-.344h12.9a.346.346 0 0 1 .344.344Zm0-11.377a.346.346 0 0 1-.344.344h-12.898a.344.344 0 0 1-.346-.344v-4.4a.347.347 0 0 1 .346-.347h12.9a.347.347 0 0 1 .344.347Zm0-11.381a.346.346 0 0 1-.344.347h-12.898a.346.346 0 0 1-.346-.347v-4.4a.346.346 0 0 1 .346-.347h12.9a.346.346 0 0 1 .344.347Zm30.57 68.281a.344.344 0 0 1-.346.344h-12.894a.347.347 0 0 1-.347-.344v-4.409a.349.349 0 0 1 .347-.347h12.894a.346.346 0 0 1 .346.347Zm0-11.381a.346.346 0 0 1-.346.347h-12.894a.347.347 0 0 1-.347-.347v-4.406a.347.347 0 0 1 .347-.347h12.894a.346.346 0 0 1 .346.347Zm0-11.377a.346.346 0 0 1-.346.346h-12.894a.347.347 0 0 1-.347-.346V83.36a.349.349 0 0 1 .347-.347h12.894a.346.346 0 0 1 .346.347Zm0-11.381a.344.344 0 0 1-.346.346h-12.894a.346.346 0 0 1-.347-.346v-4.408a.346.346 0 0 1 .347-.346h12.894a.344.344 0 0 1 .345.346Zm0-11.379a.346.346 0 0 1-.346.347h-12.894a.349.349 0 0 1-.347-.347v-4.409a.347.347 0 0 1 .347-.344h12.894a.344.344 0 0 1 .346.344Zm0-11.377a.344.344 0 0 1-.346.344h-12.894a.347.347 0 0 1-.347-.344V49.22a.349.349 0 0 1 .347-.347h12.894a.347.347 0 0 1 .346.347Zm0-11.381a.346.346 0 0 1-.346.347h-12.894a.347.347 0 0 1-.347-.347v-4.406a.347.347 0 0 1 .347-.347h12.894a.346.346 0 0 1 .346.347Zm20.9 68.281a.346.346 0 0 1-.347.344h-12.9a.346.346 0 0 1-.346-.344v-4.414a.347.347 0 0 1 .346-.347h12.894a.347.347 0 0 1 .347.347Zm0-11.381a.346.346 0 0 1-.347.347h-12.9a.347.347 0 0 1-.345-.347v-4.411a.347.347 0 0 1 .346-.347h12.894a.346.346 0 0 1 .347.347Zm0-11.377a.347.347 0 0 1-.347.346h-12.9a.347.347 0 0 1-.345-.346V83.36a.347.347 0 0 1 .346-.347h12.894a.347.347 0 0 1 .347.347Zm0-11.381a.346.346 0 0 1-.347.346h-12.9a.346.346 0 0 1-.346-.346v-4.413a.346.346 0 0 1 .346-.346h12.894a.346.346 0 0 1 .347.346Zm0-11.379a.347.347 0 0 1-.347.347h-12.9a.347.347 0 0 1-.345-.347v-4.414a.346.346 0 0 1 .346-.344h12.894a.346.346 0 0 1 .347.344Zm0-11.377a.346.346 0 0 1-.347.344h-12.9a.346.346 0 0 1-.346-.344V49.22a.349.349 0 0 1 .346-.347h12.894a.349.349 0 0 1 .347.347Zm0-11.381a.346.346 0 0 1-.347.347h-12.9a.347.347 0 0 1-.345-.347v-4.411a.347.347 0 0 1 .346-.347h12.894a.346.346 0 0 1 .347.347Zm30.572 68.266a.347.347 0 0 1-.347.344h-12.9a.346.346 0 0 1-.347-.344v-4.4a.347.347 0 0 1 .347-.347h12.894a.349.349 0 0 1 .352.347Zm0-11.381a.347.347 0 0 1-.347.347h-12.9a.346.346 0 0 1-.347-.347v-4.4a.346.346 0 0 1 .347-.347h12.894a.347.347 0 0 1 .347.347Zm0-11.377a.347.347 0 0 1-.347.346h-12.9a.347.347 0 0 1-.347-.346v-4.4a.347.347 0 0 1 .347-.347h12.894a.349.349 0 0 1 .352.347Zm0-11.381a.346.346 0 0 1-.347.346h-12.9a.346.346 0 0 1-.347-.346v-4.4a.346.346 0 0 1 .347-.346h12.894a.346.346 0 0 1 .347.346Zm0-11.379a.349.349 0 0 1-.347.347h-12.9a.347.347 0 0 1-.347-.347v-4.4a.346.346 0 0 1 .347-.344h12.894a.347.347 0 0 1 .347.344Zm0-11.377a.347.347 0 0 1-.347.344h-12.9a.346.346 0 0 1-.347-.344v-4.4a.349.349 0 0 1 .347-.347h12.894a.349.349 0 0 1 .352.347Zm0-11.381a.347.347 0 0 1-.347.347h-12.9a.346.346 0 0 1-.347-.347v-4.4a.346.346 0 0 1 .347-.347h12.894a.347.347 0 0 1 .347.347Z"
        data-name="Path 123635"
      />
      <path
        fill="#e7ebf0"
        d="m-157.854 6.195-2.82 1.793 1.711-3.11a2.779 2.779 0 0 0-1.7-.609h-.044a3.291 3.291 0 0 1-.586-.044l-.956.605.41-.744a3.414 3.414 0 0 1-1.672-1.269l-1.709 1.084 1.081-1.965a5 5 0 0 0-3.827-1.938 5.251 5.251 0 0 0-4.385 2.7 3.276 3.276 0 0 1-2.9 1.563h-.1c-1.963 0-3.556 2.226-3.556 4.972s1.593 4.972 3.556 4.972a2.659 2.659 0 0 0 1.237-.311 5.161 5.161 0 0 1 4.3-.084 4.478 4.478 0 0 0 3.659.008 5.143 5.143 0 0 1 4.265.082 2.644 2.644 0 0 0 1.224.3c1.963 0 3.556-2.226 3.556-4.972a6.323 6.323 0 0 0-.744-3.033Z"
        data-name="Path 123636"
      />
      <path
        d="M-163.168 13.476a5.255 5.255 0 0 0-3.045.329 4.492 4.492 0 0 1-3.658 0 5.125 5.125 0 0 0-4.3.084 2.664 2.664 0 0 1-1.239.309c-1.744 0-3.194-1.757-3.5-4.074a3.354 3.354 0 0 0 .872-.939 4.9 4.9 0 0 1 8.75-.038 3.361 3.361 0 0 0 2.9 1.593h.044a3.646 3.646 0 0 1 3.176 2.736Z"
        data-name="Path 123637"
        opacity={0.03}
      />
      <path
        fill="#e7ebf0"
        d="m-61.056 18.5-1.988 1.26 1.206-2.193a1.964 1.964 0 0 0-1.2-.429h-.031a2.452 2.452 0 0 1-.413-.031l-.673.428.288-.525a2.407 2.407 0 0 1-1.178-.9l-1.2.775.76-1.385a3.512 3.512 0 0 0-2.7-1.364 3.7 3.7 0 0 0-3.09 1.907 2.3 2.3 0 0 1-2.043 1.1h-.067c-1.384 0-2.5 1.57-2.5 3.5s1.12 3.5 2.5 3.5a1.884 1.884 0 0 0 .874-.219 3.62 3.62 0 0 1 3.032-.059 3.158 3.158 0 0 0 2.577 0 3.62 3.62 0 0 1 3.006.058 1.884 1.884 0 0 0 .864.214c1.384 0 2.506-1.57 2.506-3.5a4.455 4.455 0 0 0-.53-2.137Z"
        data-name="Path 123638"
      />
      <path
        d="M-64.801 23.635a3.7 3.7 0 0 0-2.139.232 3.153 3.153 0 0 1-2.578 0 3.62 3.62 0 0 0-3.032.059 1.877 1.877 0 0 1-.872.219c-1.229 0-2.253-1.239-2.468-2.873a2.36 2.36 0 0 0 .614-.658 3.456 3.456 0 0 1 6.168-.021 2.373 2.373 0 0 0 2.042 1.122h.031a2.532 2.532 0 0 1 2.234 1.92Z"
        data-name="Path 123639"
        opacity={0.03}
      />
      <path
        fill="#e7ebf0"
        d="m-85.908 6.689-1.39.882.844-1.54a1.377 1.377 0 0 0-.841-.3h-.023a1.522 1.522 0 0 1-.288-.021l-.472.3.2-.369a1.667 1.667 0 0 1-.823-.625l-.844.535.533-.969a2.468 2.468 0 0 0-1.89-.956 2.59 2.59 0 0 0-2.164 1.336 1.622 1.622 0 0 1-1.431.772h-.046c-.969 0-1.754 1.1-1.754 2.453s.783 2.452 1.752 2.452a1.317 1.317 0 0 0 .61-.153 2.524 2.524 0 0 1 2.122-.041 2.244 2.244 0 0 0 .908.194 2.221 2.221 0 0 0 .9-.191 2.539 2.539 0 0 1 2.1.041 1.316 1.316 0 0 0 .606.15c.967 0 1.754-1.1 1.754-2.453a3.126 3.126 0 0 0-.363-1.497Z"
        data-name="Path 123640"
      />
      <path
        d="M-88.529 10.27a2.6 2.6 0 0 0-1.5.165 2.221 2.221 0 0 1-1.81 0 2.537 2.537 0 0 0-2.122.041 1.3 1.3 0 0 1-.61.153c-.862 0-1.578-.867-1.726-2.011a1.633 1.633 0 0 0 .429-.464 2.422 2.422 0 0 1 4.319-.018 1.657 1.657 0 0 0 1.43.786h.021a1.8 1.8 0 0 1 1.569 1.348Z"
        data-name="Path 123641"
        opacity={0.03}
      />
      <path
        fill="none"
        stroke="#3f3d56"
        strokeWidth={4}
        d="M-181.557 127.464a1.874 1.874 0 0 0-.494-1.951 3.122 3.122 0 0 1-.967-1.851c.016-1.022 1.1-1.626 1.974-2.167a9.614 9.614 0 0 0 1.769-1.422 2.6 2.6 0 0 0 .543-.727 2.971 2.971 0 0 0 .165-1.292q-.058-2.188-.217-4.373"
        data-name="Path 123642"
      />
      <path
        fill="#57b894"
        d="M-177.135 113.603a1.594 1.594 0 0 0-.8-1.306l-.357.706.012-.854a1.594 1.594 0 1 0 1.142 1.454Z"
        data-name="Path 123643"
      />
      <path
        fill="#57b894"
        d="M-179.985 124.394a1.594 1.594 0 0 1-3.011-.658 1.619 1.619 0 0 1 .1-.647 1.6 1.6 0 0 1 2.985.016l-1 .811 1.094-.253a1.578 1.578 0 0 1-.168.731Z"
        data-name="Path 123644"
      />
      <path
        fill="#57b894"
        d="M-180.767 121.293a1.594 1.594 0 0 1-1.667-1.519 1.576 1.576 0 0 1 .138-.726 1.6 1.6 0 0 1 1.023-.883v.658l.36-.714a1.594 1.594 0 0 1 1.667 1.519 1.565 1.565 0 0 1-.067.543 1.6 1.6 0 0 1-1.454 1.122Z"
        data-name="Path 123645"
      />
      <path
        fill="#57b894"
        d="M-176.896 118.722a1.6 1.6 0 1 1 .7-2.985l-.281.773.579-.558a1.588 1.588 0 0 1 .515 1.1 1.553 1.553 0 0 1-.039.439 1.594 1.594 0 0 1-1.474 1.231Z"
        data-name="Path 123646"
      />
      <path
        d="M-177.349 114.027c-.369.041-.726.155-1.1.178a1.191 1.191 0 0 1-1.009-.352 4.865 4.865 0 0 1-.295-.52 1.13 1.13 0 0 0-.4-.377 1.594 1.594 0 1 0 2.98 1.058 3.747 3.747 0 0 0-.176.013Z"
        data-name="Path 123647"
        opacity={0.1}
      />
      <path
        d="M-176.895 118.722a1.6 1.6 0 0 1-1.517-2.275 1.2 1.2 0 0 1 .321.329 5.319 5.319 0 0 0 .316.526 1.311 1.311 0 0 0 1.058.37c.385-.016.755-.128 1.139-.165a.947.947 0 0 0 .165-.01 1.594 1.594 0 0 1-1.482 1.225Z"
        data-name="Path 123648"
        opacity={0.1}
      />
      <path
        d="M-180.767 121.297a1.594 1.594 0 0 1-1.667-1.519 1.576 1.576 0 0 1 .138-.726 1.317 1.317 0 0 1 .337.329 5.411 5.411 0 0 0 .346.536 1.467 1.467 0 0 0 1.129.4c.408-.01.775-.105 1.168-.136a1.6 1.6 0 0 1-1.451 1.116Z"
        data-name="Path 123649"
        opacity={0.1}
      />
      <path
        d="M-179.985 124.394a1.594 1.594 0 0 1-3.011-.658 1.619 1.619 0 0 1 .1-.647 1.562 1.562 0 0 1 .35.313 6.616 6.616 0 0 0 .426.566 2 2 0 0 0 1.316.464 6.927 6.927 0 0 0 .819-.038Z"
        data-name="Path 123650"
        opacity={0.1}
      />
      <path
        fill="#656380"
        d="M-183.96 127.198a13.061 13.061 0 0 0 1.645-.762c.387-.268 1.937-.594 2.03-.165s1.882 2.159.467 2.17-3.3.234-3.681 0-.461-1.243-.461-1.243Z"
        data-name="Path 123651"
      />
      <path
        d="M-179.797 128.29c-1.42.011-3.3.234-3.679 0-.288-.176-.4-.806-.443-1.1h-.041s.079 1.015.457 1.245 2.259.01 3.681 0c.41 0 .551-.15.545-.365-.058.137-.211.219-.52.22Z"
        data-name="Path 123652"
        opacity={0.2}
      />
      <path
        fill="none"
        stroke="#3f3d56"
        strokeWidth={4}
        d="M-93.738 127.553a1.278 1.278 0 0 1 .329-1.316 2.122 2.122 0 0 0 .648-1.244c-.01-.686-.739-1.091-1.316-1.454a6.5 6.5 0 0 1-1.186-.954 1.76 1.76 0 0 1-.365-.494 2.007 2.007 0 0 1-.11-.869q.04-1.469.146-2.935"
        data-name="Path 123653"
      />
      <path
        fill="#57b894"
        d="M-96.706 118.241a1.071 1.071 0 0 1 .535-.877l.24.474-.008-.574a1.052 1.052 0 0 1 .354-.041 1.071 1.071 0 1 1-1.12 1.018Z"
        data-name="Path 123654"
      />
      <path
        fill="#57b894"
        d="M-94.796 125.491a1.07 1.07 0 1 0-.053-.862l.67.543-.737-.165a1.073 1.073 0 0 0 .12.484Z"
        data-name="Path 123655"
      />
      <path
        fill="#57b894"
        d="M-94.261 123.412a1.069 1.069 0 0 0 1.119-1.02 1.052 1.052 0 0 0-.092-.494 1.066 1.066 0 0 0-.688-.592v.441l-.244-.48a1.073 1.073 0 0 0-1.12 1.02 1.122 1.122 0 0 0 .046.365 1.071 1.071 0 0 0 .979.76Z"
        data-name="Path 123656"
      />
      <path
        fill="#57b894"
        d="M-96.867 121.682a1.071 1.071 0 1 0-.474-2l.189.518-.388-.373a1.068 1.068 0 0 0-.346.739 1.042 1.042 0 0 0 .026.3 1.071 1.071 0 0 0 .993.816Z"
        data-name="Path 123657"
      />
      <path
        d="M-96.563 118.53c.247.026.494.1.735.118a.8.8 0 0 0 .68-.244 3.631 3.631 0 0 0 .2-.349.761.761 0 0 1 .268-.253 1.047 1.047 0 0 1 .115.535 1.071 1.071 0 0 1-2.116.176c.039.009.079.012.118.017Z"
        data-name="Path 123658"
        opacity={0.1}
      />
      <path
        d="M-96.867 121.683a1.069 1.069 0 0 0 1.018-1.527.791.791 0 0 0-.222.224 3.191 3.191 0 0 1-.212.354.874.874 0 0 1-.709.248c-.258-.011-.508-.086-.765-.109h-.109a1.071 1.071 0 0 0 .999.81Z"
        data-name="Path 123659"
        opacity={0.1}
      />
      <path
        d="M-94.261 123.412a1.069 1.069 0 0 0 1.119-1.02 1.05 1.05 0 0 0-.092-.494.859.859 0 0 0-.225.217 3.474 3.474 0 0 1-.234.362.987.987 0 0 1-.757.265c-.267 0-.522-.071-.785-.09a1.071 1.071 0 0 0 .974.76Z"
        data-name="Path 123660"
        opacity={0.1}
      />
      <path
        d="M-94.796 125.492a3.061 3.061 0 1 1 1.716-.665 4.257 4.257 0 0 1-.286.38 1.339 1.339 0 0 1-.887.313 4.919 4.919 0 0 1-.543-.028Z"
        data-name="Path 123661"
        opacity={0.1}
      />
      <path
        fill="#656380"
        d="M-92.122 127.261a5.286 5.286 0 0 1-1.1-.4c-.255-.181-1.3-.4-1.362-.107s-1.27 1.446-.316 1.454a10.035 10.035 0 0 0 2.468-.112c.251-.153.31-.835.31-.835Z"
        data-name="Path 123662"
      />
      <path
        d="M-94.919 128.115a10.464 10.464 0 0 0 2.468-.112c.194-.117.271-.541.3-.735h.033s-.054.683-.308.838a10.136 10.136 0 0 1-2.468.112c-.276 0-.37-.1-.365-.245.031.078.136.142.34.142Z"
        data-name="Path 123663"
        opacity={0.2}
      />
      <path
        fill="#3f3d56"
        d="M-172.216 128.21h83.747v.329h-83.747z"
        data-name="Rectangle 58859"
      />
      <path
        fill="#3f3d56"
        d="M-85.508 128.21h44.424v.329h-44.424z"
        data-name="Rectangle 58860"
      />
      <path
        fill="#3f3d56"
        d="M-244.61 128.21h69.432v.329h-69.432z"
        data-name="Rectangle 58861"
      />
      <g
        data-name="Group 137760"
        opacity={0.998}
        transform="translate(-237.86 34.907)"
      >
        <circle
          cx={0.911}
          cy={0.911}
          r={0.911}
          fill="#80b2b7"
          data-name="Ellipse 130947"
          transform="translate(14.252)"
        />
        <path
          fill="#80b2b7"
          d="M15.453 14.951 14.872.713l.535-.022.582 14.238z"
          data-name="Rectangle 58412"
        />
        <path
          fill="#80b2b7"
          d="m14.929.924.132-.519 44.924 14.5-.132.519Z"
          data-name="Path 123529"
        />
        <path
          fill="#80b2b7"
          d="m14.915.681.424.328-14.914 12.6-.424-.328Z"
          data-name="Path 123530"
        />
        <path
          fill="#80b2b7"
          d="m12.959 14.931-.527-.097L15.009.82l.527.097z"
          data-name="Rectangle 58413"
        />
        <path
          fill="#80b2b7"
          d="M27.002 13.285h1.286v4.178h-1.286z"
          data-name="Rectangle 58414"
        />
        <path
          fill="#80b2b7"
          d="M24.002 13.285h1.286v4.178h-1.286z"
          data-name="Rectangle 58415"
        />
        <path
          fill="#80b2b7"
          d="m2.105 17.636-1.286-.024.08-4.178 1.285.025z"
          data-name="Rectangle 58416"
        />
        <path
          fill="#80b2b7"
          d="m4.013 17.642-1.286-.037.121-4.178 1.286.037z"
          data-name="Rectangle 58417"
        />
        <path
          fill="#80b2b7"
          d="m5.834 17.642-1.286-.037.121-4.178 1.286.037z"
          data-name="Rectangle 58418"
        />
        <path
          fill="#80b2b7"
          d="M20.573 13.285h1.286v4.178h-1.286z"
          data-name="Rectangle 58419"
        />
        <path
          fill="#80b2b7"
          d="m15.539 17.927-.003-.624 24.001-.107.003.624z"
          data-name="Rectangle 58420"
        />
        <path
          fill="#80b2b7"
          d="M.003 13.741 0 13.052l35.89-.16.004.69z"
          data-name="Rectangle 58421"
        />
        <path
          fill="#80b2b7"
          d="M43.281.321h.261v8.428h-.261z"
          data-name="Rectangle 58422"
        />
        <path
          fill="#80b2b7"
          d="m37.608 5.678 11.035.536v1.929l-11.035-.536Z"
          data-name="Path 123531"
        />
        <path
          fill="#80b2b7"
          d="m38.572 6.786 9.286.062v7.3l-9.357-.643Z"
          data-name="Path 123532"
        />
        <path
          fill="#80b2b7"
          d="m27.666 10.928 63.62 3.214v1.929l-63.62-3.214Z"
          data-name="Path 123533"
        />
        <path
          fill="#80b2b7"
          d="m88.678 13.906 1.929.321 1.179 2.143h-3.108Z"
          data-name="Path 123534"
        />
        <path
          fill="#80b2b7"
          d="M91.143 16.334a.751.751 0 1 1 .75.714.733.733 0 0 1-.75-.714Z"
          data-name="Path 123535"
        />
        <path
          fill="#547d7f"
          d="M91.928 16.691h.143v19h-.143z"
          data-name="Rectangle 58423"
        />
        <path
          fill="#547d7f"
          d="M91.607 35.53a.377.377 0 1 1 .375.339.358.358 0 0 1-.375-.339Z"
          data-name="Path 123536"
        />
        <path
          fill="#547d7f"
          d="m94.264 38.869-2.155-3.37.09-.057 2.155 3.37z"
          data-name="Rectangle 58424"
        />
        <path
          fill="#547d7f"
          d="m89.886 39.076-.094-.052 1.929-3.504.093.052z"
          data-name="Rectangle 58425"
        />
        <path
          fill="#547d7f"
          d="M89.571 38.691h5.393v.714h-5.393z"
          data-name="Rectangle 58426"
        />
        <path
          fill="#9dd6d6"
          d="m25.609 10.5 66.213 3.536V15l-66.213-3.536Z"
          data-name="Path 123537"
        />
        <path
          fill="#80b2b7"
          d="M17.353 18.857h.434v73.82h-.434z"
          data-name="Rectangle 58427"
        />
        <path
          fill="#80b2b7"
          d="M12.431 18.857h.434v73.82h-.434z"
          data-name="Rectangle 58428"
        />
        <path
          fill="#80b2b7"
          d="m12.538 84.684.11-.9 4.959 6.321-.163.924Z"
          data-name="Path 123538"
        />
        <path
          fill="#80b2b7"
          d="m12.549 90.237.024.819 5.095-6.019-.07-.839Z"
          data-name="Path 123539"
        />
        <path
          fill="#80b2b7"
          d="m12.538 77.398.11-.9 4.959 6.321-.163.924Z"
          data-name="Path 123540"
        />
        <path
          fill="#80b2b7"
          d="m12.549 82.951.024.819 5.095-6.019-.07-.839Z"
          data-name="Path 123541"
        />
        <path
          fill="#80b2b7"
          d="m12.538 69.845.11-.9 4.959 6.321-.163.924Z"
          data-name="Path 123542"
        />
        <path
          fill="#80b2b7"
          d="m12.549 75.398.024.819 5.095-6.019-.07-.839Z"
          data-name="Path 123543"
        />
        <path
          fill="#80b2b7"
          d="m12.538 62.559.11-.9 4.959 6.321-.163.924Z"
          data-name="Path 123544"
        />
        <path
          fill="#80b2b7"
          d="m12.549 68.111.024.819 5.095-6.019-.07-.839Z"
          data-name="Path 123545"
        />
        <path
          fill="#80b2b7"
          d="m12.538 55.185.11-.9 4.959 6.321-.163.924Z"
          data-name="Path 123546"
        />
        <path
          fill="#80b2b7"
          d="m12.549 60.734.024.819 5.095-6.019-.07-.839Z"
          data-name="Path 123547"
        />
        <path
          fill="#80b2b7"
          d="m12.538 47.899.11-.9 4.959 6.321-.163.924Z"
          data-name="Path 123548"
        />
        <path
          fill="#80b2b7"
          d="m12.549 53.448.024.819 5.095-6.019-.07-.838Z"
          data-name="Path 123549"
        />
        <path
          fill="#80b2b7"
          d="m12.538 40.346.11-.9 4.959 6.321-.163.924Z"
          data-name="Path 123550"
        />
        <path
          fill="#80b2b7"
          d="m12.549 45.898.024.819 5.095-6.019-.07-.838Z"
          data-name="Path 123551"
        />
        <path
          fill="#80b2b7"
          d="m12.538 33.06.11-.9 4.959 6.321-.163.924Z"
          data-name="Path 123552"
        />
        <path
          fill="#80b2b7"
          d="m12.549 38.612.024.819 5.095-6.019-.07-.838Z"
          data-name="Path 123553"
        />
        <path
          fill="#80b2b7"
          d="m12.538 26.739.11-.9 4.959 6.321-.163.924Z"
          data-name="Path 123554"
        />
        <path
          fill="#80b2b7"
          d="m12.549 32.291.024.819 5.095-6.019-.07-.839Z"
          data-name="Path 123555"
        />
        <path
          fill="#80b2b7"
          d="m12.538 19.454.11-.9 4.959 6.321-.163.924Z"
          data-name="Path 123556"
        />
        <path
          fill="#80b2b7"
          d="m12.549 25.006.024.819 5.095-6.019-.07-.838Z"
          data-name="Path 123557"
        />
        <path
          fill="#80b2b7"
          d="M11.788 13.464h6.5v6.571h-6.5z"
          data-name="Rectangle 58429"
        />
        <path
          fill="#80b2b7"
          d="M9.431 15.607h4.5v6.571h-4.5z"
          data-name="Rectangle 58430"
        />
        <path
          fill="#efda86"
          d="M507.666 127h3.714v6.123h-1.926v-2.962l-1.788-1.339Z"
          data-name="Path 123558"
          opacity={0.4}
          style={{
            mixBlendMode: "overlay",
            isolation: "isolate",
          }}
          transform="translate(-495.878 -113.393)"
        />
        <path
          fill="#efda86"
          d="M0 0h1.926v3.853H0z"
          data-name="Rectangle 58431"
          opacity={0.4}
          style={{
            mixBlendMode: "overlay",
            isolation: "isolate",
          }}
          transform="translate(9.826 16.145)"
        />
        <path
          fill="#80b2b7"
          d="M11.145 86.676h7.821v6.964h-7.821z"
          data-name="Rectangle 58432"
        />
        <path
          fill="#80b2b7"
          d="M1.717 88.819h9.857v2.357H1.717z"
          data-name="Rectangle 58433"
        />
        <path
          fill="#80b2b7"
          d="M1.762 86.133h9.775v2.125H1.762z"
          data-name="Rectangle 58434"
        />
        <path
          fill="#80b2b7"
          d="M1.762 82.733h9.775v2.55H1.762z"
          data-name="Rectangle 58435"
        />
        <path
          fill="#80b2b7"
          d="M9.538 82.391h.643v9.321h-.643z"
          data-name="Rectangle 58436"
        />
        <path
          fill="#80b2b7"
          d="M3.216 82.391h.643v9.321h-.643z"
          data-name="Rectangle 58437"
        />
      </g>
    </g>
  </svg>
)
export default NoTimelineImg
